import { render, staticRenderFns } from "./fichaApoyoCliente.vue?vue&type=template&id=44b5f690&scoped=true"
import script from "./fichaApoyoCliente.vue?vue&type=script&lang=js"
export * from "./fichaApoyoCliente.vue?vue&type=script&lang=js"
import style0 from "./fichaApoyoCliente.vue?vue&type=style&index=0&id=44b5f690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b5f690",
  null
  
)

export default component.exports